module.exports = __webpack_public_path__ + "img/magento-custom-development_medium.6581e805.jpg";